export default __webpack_public_path__ + "static/media/iusdup.ec152a01.svg";